import React from 'react'
import classNames from 'classnames'

import { breakpoints, spacing, colors } from '../../utils/styles'

const ProductListingHeader = ({ title, subtitle, image }) => {
  const styleHeader = {}
  if (image) {
    styleHeader.backgroundImage = `url(${image})`
  }

  return (
    <header
      className={classNames('productListingHeaderRoot sectionContainer', {
        headerImage: image,
      })}
      style={styleHeader}
    >
      {title && <h2 className="title">{title}</h2>}
      {subtitle && <h6 className="subtitle">{subtitle}</h6>}

      <style jsx>{`
        .productListingHeaderRoot {
          position: relative;
          display: flex;
          flex-direction: column;
          margin: 0 auto;
          justify-content: center;
          overflow: hidden;
        }
        .headerImage {
          height: 340px;
          background-repeat: no-repeat;
          background-position: 50% 50%;
          background-size: cover;
        }

        .title {
          text-shadow: 0 0 2px rgba(255, 255, 255, 0.5);
          color: ${image ? colors.darkest : colors.brandDark};
          margin: 0;
          margin-top: ${spacing.md}px;
          z-index: 1;
        }

        .subtitle {
          text-shadow: 0 0 2px rgba(255, 255, 255, 0.5);
          color: ${colors.darkest};
          margin: 0;
          margin-top: ${spacing.md}px;
          z-index: 1;
        }
      `}</style>
    </header>
  )
}

export default ProductListingHeader
